// Mirror of apps/api/src/common/sharepoint-url.ts. The API refuses to STORE a
// link that isn't on the company SharePoint; this is the second half, so a
// link that predates that check (or reached the database some other way) is
// never opened with window.open or handed to an <a>. React blocks `javascript:`
// in rendered hrefs, but not in window.open or in an anchor built by hand.

const SHAREPOINT_HOSTS = ['eastandwestbrook.sharepoint.com', 'eastandwestbrook-my.sharepoint.com'];

export function isTenantSharePointUrl(value: unknown): value is string {
  if (typeof value !== 'string') return false;
  let u: URL;
  try {
    u = new URL(value);
  } catch {
    return false;
  }
  return u.protocol === 'https:'
    && u.username === '' && u.password === ''
    && SHAREPOINT_HOSTS.includes(u.hostname.toLowerCase());
}
